var ProductGroupsPlugin =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 34);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};

/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Vuety;
function Vuety(id, target) {
    return function (callback) {
        if (!target.$vuety) {
            target.$vuety = {};
        }
        if (!target.$vuety[id]) {
            target.$vuety[id] = [callback];
        }
        else {
            target.$vuety[id].push(callback);
        }
    };
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = processEventArgs;
/* harmony export (immutable) */ __webpack_exports__["b"] = merge;
function processEventArgs(arg1, arg2) {
    var targetFn = null;
    var evtName = null;
    if (typeof arg1 === "string") {
        evtName = arg1;
        if (arg2 && typeof arg2 !== "string") {
            targetFn = arg2;
        }
    }
    else {
        if (arg1) {
            targetFn = arg1;
        }
        if (typeof arg2 === "string") {
            evtName = arg2;
        }
    }
    return { targetFn: targetFn, evtName: evtName };
}
function merge(key, options, handler) {
    if (!options[key]) {
        options[key] = [handler];
    }
    else if (options[key] instanceof Array) {
        options[key].push(handler);
    }
    else {
        options[key] = options[key].concat([handler]);
    }
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Component;

var defaultStore = new Map();
function Component(options) {
    var opts = options || {};
    return function (target) {
        var proto = target.prototype;
        var instance;
        var vuety = proto.$vuety;
        if (vuety) {
            var getDefault = function (key) {
                var store = defaultStore.get(target);
                if (store == null) {
                    store = {};
                    defaultStore.set(target, store);
                }
                if (key in store) {
                    return store[key];
                }
                if (!instance) {
                    instance = new target();
                }
                store[key] = instance[key];
                var t = typeof store[key];
                switch (t) {
                    case "string":
                    case "number":
                    case "boolean":
                    case "undefined":
                        break;
                    case "object":
                        if (store[key] === null) {
                            break;
                        }
                    default:
                        if (!__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.silent) {
                            console.warn("[vuety] avoid using non-primative objects via class assignment [#10]", opts.name || "(unnamed component)" + "." + key + " -> " + t);
                        }
                }
                return store[key];
            };
            var keys_1 = Object.keys(vuety);
            var doneCallbacks_1 = {};
            var data_1 = undefined;
            var _loop_1 = function (i) {
                var callbacks = vuety[keys_1[i]];
                for (var j = 0; j < callbacks.length; j++) {
                    callbacks[j]({
                        options: opts,
                        getDefault: getDefault,
                        storeData: function (key, factory) {
                            if (!data_1)
                                data_1 = {};
                            data_1[key] = factory;
                        },
                        proto: proto,
                        done: function (cb) {
                            if (!(keys_1[i] in doneCallbacks_1)) {
                                doneCallbacks_1[keys_1[i]] = cb;
                            }
                        },
                    });
                }
            };
            for (var i = 0; i < keys_1.length; i++) {
                _loop_1(i);
            }
            if (data_1) {
                var _data_1 = data_1;
                opts.data = function () {
                    var r = {};
                    Object.keys(_data_1).forEach(function (k) {
                        r[k] = _data_1[k]();
                    });
                    return r;
                };
            }
            Object.keys(doneCallbacks_1).forEach(function (decoratorId) {
                doneCallbacks_1[decoratorId]({
                    proto: proto,
                    options: opts,
                });
            });
            delete proto.$vuety;
        }
        // Loop over each method in the class and see if it needs to be set as a method or computed property
        Object.getOwnPropertyNames(target.prototype)
            .filter(function (p) { return p !== "constructor"; })
            .forEach(function (prop) {
            var descriptor = Object.getOwnPropertyDescriptor(target.prototype, prop);
            if (descriptor.get || descriptor.set) {
                delete target.prototype[prop];
                if (!opts.computed) {
                    opts.computed = {};
                }
                if (descriptor.get === undefined) {
                    throw new Error("Computed properties must have a getter: " + target.prototype.constructor.name + "." + prop);
                }
                opts.computed[prop] = {
                    get: descriptor.get,
                    set: descriptor.set,
                };
            }
            else {
                if (!opts.methods) {
                    opts.methods = {};
                }
                opts.methods[prop] = descriptor.value;
            }
        });
        if (!opts.name && target.name)
            opts.name = target.name;
        return target.extend(opts);
    };
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = Data;

function Data() {
    function data(factory, target, propertyKey) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core__["a" /* Vuety */])("Data", target)(function (v) {
            if (!factory) {
                var val_1 = v.getDefault(propertyKey);
                factory = function () { return val_1; };
            }
            v.storeData(propertyKey, factory);
        });
    }
    if (arguments.length < 3) {
        var args_1 = arguments;
        return function () {
            data.apply(this, [args_1[0]].concat(Array.from(arguments)));
        };
    }
    else {
        data.apply(this, [undefined].concat(Array.from(arguments)));
    }
    return;
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = Emit;

function Emit() {
    function emit(arg1, arg2, target, propertyKey, descriptor) {
        var r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* processEventArgs */])(arg1, arg2);
        var orig = descriptor.value;
        descriptor.value = function () {
            var target;
            if (r.targetFn) {
                target = r.targetFn(this);
            }
            else {
                target = this;
            }
            // Call original function first
            var res = orig.apply(this, arguments);
            // Then raise the event
            target.$emit.apply(target, [r.evtName || propertyKey].concat(Array.from(arguments)));
            // Then if the original function supplied a callback, invoke that
            if (typeof res === "function") {
                res.apply(this, arguments);
            }
        };
    }
    var args = Array.from(arguments);
    if (args.length === 3) {
        if ("value" in args[2] && args[2]["value"] instanceof Function) {
            emit.apply(this, Array(2).concat(args));
            return;
        }
    }
    args.length = 2;
    return function () {
        emit.apply(this, args.concat(Array.from(arguments)));
    };
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = Inject;


function Inject() {
    function inject(dependencyNameOrOptions, target, propertyKey, descriptor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core__["a" /* Vuety */])("Inject", target)(function (v) {
            if (!v.options.inject) {
                v.options.inject = {};
            }
            v.options.inject[propertyKey] = dependencyNameOrOptions || propertyKey;
            delete v.proto[propertyKey];
        });
    }
    var args = Array.from(arguments);
    if (args[0] instanceof __WEBPACK_IMPORTED_MODULE_0_vue__) {
        inject.apply(this, [undefined].concat(args));
        return;
    }
    else {
        args.length = 1;
        return function () {
            inject.apply(this, args.concat(Array.from(arguments)));
        };
    }
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = Lifecycle;

function Lifecycle() {
    function lifecycle(target, propertyKey, descriptor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core__["a" /* Vuety */])("Lifecycle", target)(function (v) {
            if (!v.options[propertyKey]) {
                v.options[propertyKey] = [descriptor.value];
            }
            else if (v.options[propertyKey] instanceof Array) {
                v.options[propertyKey].push(descriptor.value);
            }
            else {
                v.options[propertyKey] = [v.options[propertyKey], descriptor.value];
            }
        });
    }
    if (arguments.length === 0) {
        return function () {
            lifecycle.apply(this, arguments);
        };
    }
    else {
        lifecycle.apply(this, arguments);
    }
    return;
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = On;


function On() {
    var a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
    }
    function on(arg1, arg2, target, propertyKey, descriptor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core__["a" /* Vuety */])("On", target)(function (v) {
            var r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* processEventArgs */])(arg1, arg2);
            var handler = function () {
                var target = r.targetFn ? r.targetFn(this) : this;
                var listener = descriptor.value.bind(this);
                target.$on(r.evtName || propertyKey, listener);
                this.$on("hook:destroyed", function () {
                    target.$off(r.evtName || propertyKey, listener);
                });
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* merge */])("beforeCreate", v.options, handler);
        });
    }
    var args = Array.from(arguments);
    if (args.length === 3) {
        if ("value" in args[2] && args[2]["value"] instanceof Function) {
            on.apply(this, Array(2).concat(args));
            return;
        }
    }
    args.length = 2;
    return function () {
        on.apply(this, args.concat(Array.from(arguments)));
    };
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = Prop;

function Prop() {
    function prop(options, target, propertyKey) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core__["a" /* Vuety */])("Prop", target)(function (v) {
            if (!options) {
                options = {};
            }
            if (!options.default) {
                options.default = v.getDefault(propertyKey);
            }
            if (!options.type && options.default) {
                if (options.default.constructor !== Function) {
                    options.type = options.default.constructor;
                }
            }
            var props = {};
            props[propertyKey] = options;
            v.options.props = Object.assign({}, v.options.props, props);
        });
    }
    if (arguments.length < 3) {
        var args_1 = arguments;
        return function () {
            prop.apply(this, [args_1[0]].concat(Array.from(arguments)));
        };
    }
    else {
        prop.apply(this, [undefined].concat(Array.from(arguments)));
    }
    return;
}
(function (Prop) {
    Prop.warn = true;
})(Prop || (Prop = {}));


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = Provide;


function Provide() {
    function provide(dependencyName, target, propertyKey, descriptor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core__["a" /* Vuety */])("Provide", target)(function (v) {
            var provided = (v.proto["$vuety-provide"] = v.proto["$vuety-provide"] || {});
            provided[dependencyName || propertyKey] = propertyKey;
            v.done(function (data) {
                delete v.proto["$vuety-provide"];
                data.options.provide = function () {
                    var _this = this;
                    var provide = {};
                    Object.keys(provided).forEach(function (k) { return (provide[k] = _this[provided[k]]); });
                    return provide;
                };
            });
        });
    }
    var args = Array.from(arguments);
    if (args[0] instanceof __WEBPACK_IMPORTED_MODULE_0_vue__) {
        provide.apply(this, [undefined].concat(args));
        return;
    }
    else {
        args.length = 1;
        return function () {
            provide.apply(this, args.concat(Array.from(arguments)));
        };
    }
}


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = Render;

function Render() {
    function render(target, propertyKey, descriptor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core__["a" /* Vuety */])("Render", target)(function (v) {
            v.options.render = descriptor.value;
            delete v.proto.render;
        });
    }
    if (arguments.length === 0) {
        return function () {
            render.apply(this, arguments);
        };
    }
    else {
        return render.apply(this, arguments);
    }
}


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = Watch;

function Watch(watchee, options) {
    return function (target, propertyKey, descriptor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core__["a" /* Vuety */])("Watch", target)(function (v) {
            if (!options) {
                options = {};
            }
            var original = descriptor.value;
            descriptor.value = function () {
                original.apply(this, Array.from(arguments).concat([watchee]));
            };
            options["handler"] = descriptor.value;
            var watches = {};
            watches[watchee] = options;
            v.options.watch = Object.assign({}, v.options.watch, watches);
        });
    };
}


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__(3);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return __WEBPACK_IMPORTED_MODULE_0__component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(0);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Vuety", function() { return __WEBPACK_IMPORTED_MODULE_1__core__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__(4);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Data", function() { return __WEBPACK_IMPORTED_MODULE_2__data__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lifecycle__ = __webpack_require__(7);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Lifecycle", function() { return __WEBPACK_IMPORTED_MODULE_3__lifecycle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prop__ = __webpack_require__(9);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Prop", function() { return __WEBPACK_IMPORTED_MODULE_4__prop__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__render__ = __webpack_require__(11);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Render", function() { return __WEBPACK_IMPORTED_MODULE_5__render__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__watch__ = __webpack_require__(12);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Watch", function() { return __WEBPACK_IMPORTED_MODULE_6__watch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__on__ = __webpack_require__(8);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "On", function() { return __WEBPACK_IMPORTED_MODULE_7__on__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__emit__ = __webpack_require__(5);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Emit", function() { return __WEBPACK_IMPORTED_MODULE_8__emit__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__provide__ = __webpack_require__(10);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Provide", function() { return __WEBPACK_IMPORTED_MODULE_9__provide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inject__ = __webpack_require__(6);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Inject", function() { return __WEBPACK_IMPORTED_MODULE_10__inject__["a"]; });













/***/ })
/******/ ]);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* unused harmony export Root */
/* harmony export (immutable) */ __webpack_exports__["b"] = getRoot;
/* harmony export (immutable) */ __webpack_exports__["d"] = getGroupImageUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = getGroupLinkUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChild;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuety__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuety__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var Root = /** @class */ (function (_super) {
    __extends(Root, _super);
    function Root() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    Root.prototype.created = function () {
        var _this = this;
        $(window).on("popstate", function (e) {
            _this.currentGroup = e.originalEvent.state;
        });
    };
    Root.prototype.setCurrentGroup = function (options, data, pushState) {
        if (data) {
            if (window.ProductGroupsPlugin.spaNavigate) {
                if (pushState) {
                    history.pushState(data.GroupCode, data.GroupName, getGroupLinkUrl(options, data));
                }
                if (window.ProductGroupsPlugin.pageTitleTemplate) {
                    document.title = window.ProductGroupsPlugin.pageTitleTemplate.replace("[Product Groups]", data.PageTitle);
                }
            }
            this.currentGroup = data.GroupCode;
        }
        else {
            if (this.currentGroup) {
                if (window.ProductGroupsPlugin.spaNavigate && pushState) {
                    history.pushState("", "", options.groupPage);
                }
            }
            if (window.ProductGroupsPlugin.pageTitleTemplate) {
                document.title = window.ProductGroupsPlugin.pageTitleTemplate.replace("[Product Groups]", "Product Groups");
            }
            this.currentGroup = "";
        }
    };
    Root.prototype.loadData = function (options) {
        var _this = this;
        this.ajaxUrl = options.resourceUrl + "&file=productgroups.json";
        if (!this.searchTerm) {
            this.searchTerm = getQueryStringValue("description");
        }
        if (!this.currentData) {
            if (!this.loading) {
                this.loading = true;
                if (options.noCache) {
                    $.ajaxSetup({ cache: false });
                }
                $.getJSON(this.ajaxUrl)
                    .done(function (data) {
                    _this.currentData = data;
                    if (!_this.currentGroup) {
                        _this.setCurrentGroup(options, findChild(options.startingGroup, _this.currentData.Groups));
                    }
                })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log("Product Item Group data load error", textStatus, errorThrown);
                });
            }
        }
    };
    Root.prototype.currentGroupObject = function (options) {
        if (this.currentGroup) {
            return findChild(this.currentGroup, this.currentData.Groups);
        }
        else {
            if (options.rootGroup && this.currentData) {
                var root = findChild(options.rootGroup, this.currentData.Groups);
                if (!root) {
                    console.warn("No group data found for root group:", "'" + options.rootGroup + "'.", "This may be because the group is obsolete.");
                }
                return root || {};
            }
            else {
                return {};
            }
        }
    };
    Root.prototype.currentGroupChildren = function (options) {
        if (!this.currentGroup) {
            if (options.rootGroup) {
                var child = findChild(options.rootGroup, this.currentData.Groups);
                if (!child || !child.Children) {
                    console.warn("No group data found for root group:", "'" + options.rootGroup + "'.", "This may be because the group is obsolete.");
                    return [];
                }
                return child.Children;
            }
            else {
                return this.currentData.Groups;
            }
        }
        else {
            return this.currentGroupObject(options).Children || [];
        }
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Data"])()
    ], Root.prototype, "currentGroup", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Data"])()
    ], Root.prototype, "searchTerm", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Data"])()
    ], Root.prototype, "currentData", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Data"])()
    ], Root.prototype, "ajaxUrl", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Lifecycle"])()
    ], Root.prototype, "created", null);
    Root = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Component"])({
            template: "<span style='display:none'></span>",
        })
    ], Root);
    return Root;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));

var $root = new Root();
function getRoot() {
    return $root;
}
function getGroupImageUrl(options, data) {
    if (data.ImageVersion === null || +data.ImageVersion <= -1) {
        return ("/streamProductImage.aspx?type=GROUPS&ref=noimage.jpg" +
            options.imgResizerArgs);
    }
    else {
        return ("/streamProductImage.aspx?type=GROUPS&ref=" +
            data.ImageName +
            options.imgResizerArgs +
            "&ver=" +
            data.ImageVersion);
    }
}
function getGroupLinkUrl(options, data) {
    if (data.Children && data.Children.length > 0 && data.Items === 0) {
        return options.groupPageMask.replace("[GroupCode]", encodeURIComponent(data.GroupCode));
    }
    else {
        return options.productListPageMask.replace("[GroupCode]", encodeURIComponent(data.GroupCode));
    }
}
function getQueryStringValue(key) {
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" +
        encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
        "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}
function findChild(groupCode, data) {
    if (data) {
        for (var i = 0; i < data.length; i++) {
            if (groupCode !== null &&
                data[i].GroupCode.toLowerCase() === groupCode.toLowerCase()) {
                return data[i];
            }
            else {
                var child = findChild(groupCode, data[i].Children);
                if (child) {
                    return child;
                }
            }
        }
    }
    return undefined;
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(9)))

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuety__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuety__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__root__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_loadingspinner__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var BaseView = /** @class */ (function (_super) {
    __extends(BaseView, _super);
    function BaseView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseView.prototype.created = function () {
        var _this = this;
        this.currentGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__root__["b" /* getRoot */])().currentGroup;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__root__["b" /* getRoot */])().$watch("currentGroup", function () {
            _this.currentGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__root__["b" /* getRoot */])().currentGroup;
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__root__["b" /* getRoot */])().loadData(this.options);
    };
    BaseView.prototype.getGroupLinkUrl = function (item) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__root__["c" /* getGroupLinkUrl */])(this.options, item);
    };
    BaseView.prototype.getGroupImageUrl = function (item) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__root__["d" /* getGroupImageUrl */])(this.options, item);
    };
    BaseView.prototype.itemClicked = function (e, item) {
        if (window.ProductGroupsPlugin.stayOnPage &&
            item.Children &&
            item.Children.length > 0 &&
            item.Items === 0) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__root__["b" /* getRoot */])().setCurrentGroup(this.options, item, true);
            e.preventDefault();
        }
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Data"])()
    ], BaseView.prototype, "currentGroup", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Prop"])()
    ], BaseView.prototype, "options", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Lifecycle"])()
    ], BaseView.prototype, "created", null);
    BaseView = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Component"])({
            components: { "loading-spinner": __WEBPACK_IMPORTED_MODULE_3__components_loadingspinner__["a" /* LoadingSpinner */] },
        })
    ], BaseView);
    return BaseView;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));



/***/ }),
/* 4 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuety__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuety__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listItem__ = __webpack_require__(30);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var templateElement = "v-tmpl-grouplistlist";
var ListList = /** @class */ (function (_super) {
    __extends(ListList, _super);
    function ListList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Prop"])()
    ], ListList.prototype, "groups", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Prop"])()
    ], ListList.prototype, "options", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Prop"])()
    ], ListList.prototype, "parentGroupCode", void 0);
    ListList = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Component"])({
            template: document.getElementById(templateElement) ? "#" + templateElement : __webpack_require__(18),
            components: { "list-item": __WEBPACK_IMPORTED_MODULE_2__listItem__["a" /* ListItem */] },
            name: "list-list",
        })
    ], ListList);
    return ListList;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TreeItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuety__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treeList__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var templateElement = "v-tmpl-grouptreeitem";
var TreeItem = /** @class */ (function (_super) {
    __extends(TreeItem, _super);
    function TreeItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TreeItem.prototype, "isVisible", {
        get: function () {
            // item is visible if its parent is the current group, or it is the current group, or it contains a list that is visible
            return (this.currentGroup === this.parentGroupCode ||
                this.currentGroup === this.group.GroupCode ||
                this.$refs["treeList"].isVisible);
        },
        enumerable: true,
        configurable: true
    });
    TreeItem.prototype.beforeCreate = function () {
        if (this.$options && this.$options.components) {
            this.$options.components["TreeList"] = __WEBPACK_IMPORTED_MODULE_1__treeList__["a" /* TreeList */];
        }
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Prop"])()
    ], TreeItem.prototype, "group", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Prop"])()
    ], TreeItem.prototype, "parentGroupCode", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Lifecycle"])()
    ], TreeItem.prototype, "beforeCreate", null);
    TreeItem = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Component"])({
            template: document.getElementById(templateElement) ? "#" + templateElement : __webpack_require__(22),
            name: "tree-item",
            mixins: [__WEBPACK_IMPORTED_MODULE_2__base__["a" /* BaseView */]],
        })
    ], TreeItem);
    return TreeItem;
}(__WEBPACK_IMPORTED_MODULE_3_vue___default.a));



/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TreeList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuety__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuety__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__treeItem__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__root__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var templateElement = "v-tmpl-grouptreelist";
var TreeList = /** @class */ (function (_super) {
    __extends(TreeList, _super);
    function TreeList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TreeList.prototype.mounted = function () {
        var _this = this;
        var setVisible = function () {
            _this.isVisible =
                !_this.parentGroupCode || (_this.$refs["treeItem"] || []).some(function (item) { return item.isVisible; });
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__root__["b" /* getRoot */])().$watch("currentGroup", setVisible);
        setVisible();
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Prop"])()
    ], TreeList.prototype, "groups", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Prop"])()
    ], TreeList.prototype, "options", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Prop"])()
    ], TreeList.prototype, "parentGroupCode", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Data"])()
    ], TreeList.prototype, "isVisible", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Lifecycle"])()
    ], TreeList.prototype, "mounted", null);
    TreeList = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Component"])({
            template: document.getElementById(templateElement) ? "#" + templateElement : __webpack_require__(23),
            components: { "tree-item": __WEBPACK_IMPORTED_MODULE_2__treeItem__["a" /* TreeItem */] },
            name: "tree-list",
        })
    ], TreeList);
    return TreeList;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));



/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_views_thumbnail_thumbnail__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ThumbnailView", function() { return __WEBPACK_IMPORTED_MODULE_0_src_views_thumbnail_thumbnail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_views_tree_tree__ = __webpack_require__(33);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TreeView", function() { return __WEBPACK_IMPORTED_MODULE_1_src_views_tree_tree__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_views_breadcrumb_breadcrumb__ = __webpack_require__(27);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbView", function() { return __WEBPACK_IMPORTED_MODULE_2_src_views_breadcrumb_breadcrumb__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_views_childlist_childlist__ = __webpack_require__(28);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ChildListView", function() { return __WEBPACK_IMPORTED_MODULE_3_src_views_childlist_childlist__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_views_list_list__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListView", function() { return __WEBPACK_IMPORTED_MODULE_4_src_views_list_list__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_views_search_search__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SearchView", function() { return __WEBPACK_IMPORTED_MODULE_5_src_views_search_search__["a"]; });








/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "@keyframes glyphicon-spin-r {\r\n    0% {\r\n        -webkit-transform: rotate(0deg);\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(359deg);\r\n        transform: rotate(359deg);\r\n    }\r\n}\r\n.fast-right-spinner {\r\n    animation: glyphicon-spin-r 1s infinite linear;\r\n}", ""]);

// exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".group-thumbs-container .group-item-name {\r\n    text-align:center;\r\n    white-space:nowrap;\r\n    overflow:hidden;\r\n    text-overflow:ellipsis;\r\n}", ""]);

// exports


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = "<div class=\"load-wait\">\r\n    <span class=\"glyphicon glyphicon-repeat fast-right-spinner\"></span> Loading...\r\n</div>"

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = "<div class=\"group-plugin just-padding\"\r\n     v-if=\"currentGroup !== undefined\">\r\n    <ol class=\"breadcrumb group-breadcrumb-container\">\r\n        <li v-if=\"!options.rootGroup\" class=\"group-item\">\r\n            <a :href=\"options.groupPage\"\r\n               class=\"group-item-link\">\r\n                <span class=\"group-item-name\">{{options.allText}}</span>\r\n            </a>\r\n        </li>\r\n        <li class=\"group-item\"\r\n            v-for=\"group in groups\">\r\n            <a :href=\"getGroupLinkUrl(group)\"\r\n               class=\"group-item-link\"\r\n               @click=\"itemClicked($event, group)\">\r\n                <span class=\"group-item-name\">{{getGroupName(group)}}</span>\r\n            </a>\r\n        </li>\r\n    </ol>\r\n    <div v-if=\"options.showExtDesc && groupDesc\"\r\n         class=\"breadcrumb extend-desc\">{{groupDesc}}</div>\r\n</div>"

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = "<div class=\"group-plugin just-padding\" v-if=\"currentGroup !== undefined\">\r\n    <ul class=\"group-list-container list-group\">\r\n        <tree-item ref=\"treeItem\" v-for=\"group in groups\" :group=\"group\" :options=\"options\" :parentGroupCode=\"currentGroup\" />\r\n    </ul>\r\n</div>\r\n<loading-spinner v-else/>"

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = "<div class=\"group-plugin just-padding\" v-if=\"currentGroup !== undefined\"> \r\n    <list-list :groups=\"groups\" :options=\"options\"/>\r\n</div>\r\n<loading-spinner v-else/>"

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = "<li :class=\"'group-item list-group-item ' + (currentGroup === group.GroupCode ? 'selected' : '')\">\r\n    <a :href=\"getGroupLinkUrl(group)\" class=\"group-item-link\" @click=\"itemClicked($event, group)\">\r\n        <span class=\"group-item-name\">\r\n            {{group.GroupName}}\r\n        </span>\r\n        <span class=\"group-item-count badge\" v-if=\"options.showProductCount\">\r\n            {{group.AggregateItems}}\r\n        </span>\r\n    </a>\r\n    <list-list v-if=\"group.Children\" :groups=\"group.Children\" :options=\"options\" :parentGroupCode=\"group.GroupCode\"/>\r\n</li>"

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"group-list-container list-group\">\r\n    <list-item ref=\"treeItem\" v-for=\"group in groups\" :group=\"group\" :options=\"options\" :parentGroupCode=\"parentGroupCode\"/>\r\n</ul>"

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = "<div class=\"group-plugin just-padding\"\r\n     v-if=\"currentGroup !== undefined\">\r\n    <div class=\"group-search-container\">\r\n        <form class=\"form-inline\"\r\n              method=\"get\"\r\n              :action=\"options.productListPage\">\r\n            <div class=\"form-group\">\r\n                <select name=\"category\"\r\n                        class=\"group-search-dropdown form-control\"\r\n                        v-if=\"options.searchShowCats\">\r\n                    <option :value=\"options.rootGroup\"\r\n                            v-html=\"options.allSearchText\"></option>\r\n                    <option v-for=\"group in groups\"\r\n                            :value=\"group.GroupCode\"\r\n                            v-html=\"group.GroupName\"\r\n                            :selected=\"group.GroupCode == currentGroup\">\r\n                    </option>\r\n                </select>\r\n                <input type=\"hidden\"\r\n                       name=\"category\"\r\n                       :value=\"options.rootGroup\"\r\n                       v-else/>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <input type=\"text\"\r\n                       name=\"description\"\r\n                       :value=\"searchTerm\"\r\n                       class=\"form-control group-search-text\"\r\n                       placeholder=\"Search term\" />\r\n            </div>\r\n            <button type=\"submit\"\r\n                    class=\"btn btn-default\">\r\n                <span class=\"glyphicon glyphicon-search\"\r\n                      aria-hidden=\"true\"></span>&nbsp; Search</button>\r\n        </form>\r\n    </div>\r\n</div>"

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = "<div class=\"group-plugin just-padding\" v-if=\"currentGroup !== undefined\">\r\n\t<div class=\"group-thumbs-container\">\r\n\t\t<h2 class=\"group-current-title\">{{group.GroupHeading}}</h2>\r\n\t\t<p class=\"group-current-desc\" v-if=\"groupDesc\">{{groupDesc}}</p>\r\n\t\t<div\r\n\t\t\tclass=\"group-current-fulldesc\"\r\n\t\t\tv-html=\"currentFullDesc\"\r\n\t\t\tv-if=\"options.showFullDescription && !options.showFullDescBelow\"\r\n\t\t></div>\r\n\t\t<div class=\"row\">\r\n\t\t\t<div\r\n\t\t\t\tv-if=\"groups\"\r\n\t\t\t\t:data-group-id=\"item.GroupCode\"\r\n\t\t\t\tclass=\"group-item col-xs-6 col-md-3\"\r\n\t\t\t\tv-for=\"item in groups\"\r\n\t\t\t\t:key=\"item.GroupCode\"\r\n\t\t\t>\r\n\t\t\t\t<a\r\n\t\t\t\t\t:href=\"getGroupLinkUrl(item)\"\r\n\t\t\t\t\tclass=\"thumbnail group-item-link\"\r\n\t\t\t\t\t@click=\"itemClicked($event, item)\"\r\n\t\t\t\t>\r\n\t\t\t\t\t<img\r\n\t\t\t\t\t\t:src=\"getGroupImageUrl(item)\"\r\n\t\t\t\t\t\tclass=\"group-item-image\"\r\n\t\t\t\t\t\t:alt=\"item.GroupName\"\r\n\t\t\t\t\t/>\r\n\t\t\t\t\t<div class=\"group-item-name\">{{item.GroupName}}</div>\r\n\t\t\t\t\t<span class=\"group-item-desc\">{{eachDescription(item)}}</span>\r\n\t\t\t\t</a>\r\n\t\t\t\t<div\r\n\t\t\t\t\tclass=\"thumbnail-subcategories\"\r\n\t\t\t\t\tv-if=\"options.showSubCategoryForEach\"\r\n\t\t\t\t>\r\n\t\t\t\t\t<div\r\n\t\t\t\t\t\tclass=\"thumbnail-subcategory\"\r\n\t\t\t\t\t\tv-for=\"subCategory in getSubCategories(item)\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t\t<a\r\n\t\t\t\t\t\t\t:href=\"getGroupLinkUrl(subCategory)\"\r\n\t\t\t\t\t\t\t@click=\"itemClicked($event, subCategory)\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t{{subCategory.GroupName}}\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div v-else class=\"group-thumbs-empty\">This group is empty</div>\r\n\t\t</div>\r\n\t\t<div class=\"row\" v-if=\"listThumbnails\">\r\n\t\t\t<div class=\"thumbnail-list\">\r\n\t\t\t\t<div class=\"list\" v-for=\"list in listThumbnails\">\r\n\t\t\t\t\t<a :href=\"getGroupLinkUrl(list)\" @click=\"itemClicked($event, list)\">\r\n\t\t\t\t\t\t{{list.GroupName}}\r\n\t\t\t\t\t</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div\r\n\t\t\tclass=\"group-current-fulldesc\"\r\n\t\t\tv-html=\"currentFullDesc\"\r\n\t\t\tv-if=\"options.showFullDescription && options.showFullDescBelow\"\r\n\t\t></div>\r\n\t</div>\r\n</div>\r\n<loading-spinner v-else />\r\n"

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = "<div class=\"group-plugin just-padding\" v-if=\"currentGroup !== undefined\"> \r\n    <tree-list :groups=\"groups\" :options=\"options\"/>\r\n</div>\r\n<loading-spinner v-else/>"

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = "<li :class=\"'group-item list-group-item ' + (currentGroup === group.GroupCode ? 'selected' : '')\">\r\n    <a :href=\"getGroupLinkUrl(group)\" class=\"group-item-link\" @click=\"itemClicked($event, group)\">\r\n        <span class=\"group-item-name\">\r\n            {{group.GroupName}}\r\n        </span>\r\n        <span class=\"group-item-count badge\" v-if=\"options.showProductCount\">\r\n            {{group.AggregateItems}}\r\n        </span>\r\n    </a>\r\n    <tree-list ref=\"treeList\" v-if=\"group.Children\" :groups=\"group.Children\" :options=\"options\" :parentGroupCode=\"group.GroupCode\"/>\r\n</li>"

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"group-list-container list-group\" :style=\"isVisible ? '' : 'display:none'\">\r\n    <tree-item ref=\"treeItem\" v-for=\"group in groups\" :group=\"group\" :options=\"options\" :parentGroupCode=\"parentGroupCode\"/>\r\n</ul>"

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(11);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!./loadingspinner.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!./loadingspinner.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(12);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(5)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!./thumbnail.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!./thumbnail.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingSpinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuety__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuety__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loadingspinner_css__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loadingspinner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loadingspinner_css__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var templateElement = "v-tmpl-spinner";
var LoadingSpinner = /** @class */ (function (_super) {
    __extends(LoadingSpinner, _super);
    function LoadingSpinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingSpinner = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuety__["Component"])({
            template: document.getElementById(templateElement) ? "#" + templateElement
                : __webpack_require__(13)
        })
    ], LoadingSpinner);
    return LoadingSpinner;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));



/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BreadcrumbView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuety__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var templateElement = "v-tmpl-groupbreadcrumb";
var BreadcrumbView = /** @class */ (function (_super) {
    __extends(BreadcrumbView, _super);
    function BreadcrumbView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BreadcrumbView.prototype, "groups", {
        get: function () {
            var groupChain = [];
            var thisGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["a" /* findChild */])(this.currentGroup, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentData.Groups);
            while (thisGroup) {
                groupChain.unshift(thisGroup);
                var parentCode = thisGroup.ParentCode;
                if (parentCode) {
                    thisGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["a" /* findChild */])(parentCode, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentData.Groups);
                }
                else {
                    thisGroup = undefined;
                }
            }
            return groupChain;
        },
        enumerable: true,
        configurable: true
    });
    BreadcrumbView.prototype.getGroupName = function (group) {
        if (this.options.allText &&
            this.options.rootGroup &&
            group.GroupCode.toLowerCase() === this.options.rootGroup.toLowerCase()) {
            return this.options.allText;
        }
        return group.GroupName;
    };
    Object.defineProperty(BreadcrumbView.prototype, "groupDesc", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentGroupObject(this.options).GroupDesc;
        },
        enumerable: true,
        configurable: true
    });
    BreadcrumbView = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Component"])({
            template: document.getElementById(templateElement)
                ? "#" + templateElement
                : __webpack_require__(14),
            mixins: [__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseView */]]
        })
    ], BreadcrumbView);
    return BreadcrumbView;
}(__WEBPACK_IMPORTED_MODULE_2_vue___default.a));



/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChildListView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuety__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tree_treeItem__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var templateElement = "v-tmpl-groupchildlist";
var ChildListView = /** @class */ (function (_super) {
    __extends(ChildListView, _super);
    function ChildListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ChildListView.prototype, "groups", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentGroupChildren(this.options);
        },
        enumerable: true,
        configurable: true
    });
    ChildListView = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Component"])({
            template: document.getElementById(templateElement)
                ? "#" + templateElement
                : __webpack_require__(15),
            components: { "tree-item": __WEBPACK_IMPORTED_MODULE_3__tree_treeItem__["a" /* TreeItem */] },
            mixins: [__WEBPACK_IMPORTED_MODULE_2__base__["a" /* BaseView */]]
        })
    ], ChildListView);
    return ChildListView;
}(__WEBPACK_IMPORTED_MODULE_4_vue___default.a));



/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuety__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listList__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var templateElement = "v-tmpl-grouplist";
var ListView = /** @class */ (function (_super) {
    __extends(ListView, _super);
    function ListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ListView.prototype, "groups", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentData.Groups;
        },
        enumerable: true,
        configurable: true
    });
    ListView = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Component"])({
            template: document.getElementById(templateElement) ? "#" + templateElement : __webpack_require__(16),
            components: { "list-list": __WEBPACK_IMPORTED_MODULE_2__listList__["a" /* ListList */] },
            mixins: [__WEBPACK_IMPORTED_MODULE_4__base__["a" /* BaseView */]],
        })
    ], ListView);
    return ListView;
}(__WEBPACK_IMPORTED_MODULE_3_vue___default.a));



/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuety__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listList__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var templateElement = "v-tmpl-grouplistitem";
var ListItem = /** @class */ (function (_super) {
    __extends(ListItem, _super);
    function ListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListItem.prototype.beforeCreate = function () {
        if (this.$options && this.$options.components) {
            this.$options.components["ListList"] = __WEBPACK_IMPORTED_MODULE_1__listList__["a" /* ListList */];
        }
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Prop"])()
    ], ListItem.prototype, "group", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Prop"])()
    ], ListItem.prototype, "parentGroupCode", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Lifecycle"])()
    ], ListItem.prototype, "beforeCreate", null);
    ListItem = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Component"])({
            template: document.getElementById(templateElement) ? "#" + templateElement : __webpack_require__(17),
            name: "list-item",
            mixins: [__WEBPACK_IMPORTED_MODULE_2__base__["a" /* BaseView */]],
        })
    ], ListItem);
    return ListItem;
}(__WEBPACK_IMPORTED_MODULE_3_vue___default.a));



/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuety__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var templateElement = "v-tmpl-groupsearch";
var SearchView = /** @class */ (function (_super) {
    __extends(SearchView, _super);
    function SearchView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SearchView.prototype, "groups", {
        get: function () {
            if (this.options.rootGroup) {
                var child = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["a" /* findChild */])(this.options.rootGroup, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentData.Groups);
                if (!child) {
                    console.warn("No group data found for root group:", "'" + this.options.rootGroup + "'.", "This may be because the group is obsolete.");
                    return [];
                }
                return this.getGroupStructure(child.Children, 0);
            }
            else {
                return this.getGroupStructure(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentData.Groups, 0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchView.prototype, "searchTerm", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().searchTerm;
        },
        enumerable: true,
        configurable: true
    });
    SearchView.prototype.getGroupStructure = function (groups, depth) {
        var indentedGroups = [];
        if (depth < this.options.searchCatDepth) {
            var indentedGroups_1 = [];
            for (var i = 0; i < groups.length; i++) {
                var thisGroup = Object.assign({}, groups[i]);
                thisGroup.GroupName = this.pad(depth) + thisGroup.GroupName;
                indentedGroups_1.push(thisGroup);
                if (groups[i].Children) {
                    indentedGroups_1.push.apply(indentedGroups_1, this.getGroupStructure(groups[i].Children, depth + 1));
                }
            }
            return indentedGroups_1;
        }
        else {
            return indentedGroups;
        }
    };
    SearchView.prototype.pad = function (count) {
        var output = "";
        for (var i = 0; i < count; i++) {
            output += "&nbsp;&nbsp;&nbsp;&nbsp;";
        }
        return output;
    };
    SearchView = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Component"])({
            template: document.getElementById(templateElement)
                ? "#" + templateElement
                : __webpack_require__(19),
            mixins: [__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseView */]]
        })
    ], SearchView);
    return SearchView;
}(__WEBPACK_IMPORTED_MODULE_2_vue___default.a));



/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThumbnailView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuety__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_thumbnail_css__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_thumbnail_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_thumbnail_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var templateElement = "v-tmpl-groupthumbnail";
var ThumbnailView = /** @class */ (function (_super) {
    __extends(ThumbnailView, _super);
    function ThumbnailView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThumbnailView.prototype.mounted = function () {
        var _this = this;
        window.ProductGroupsPlugin.stayOnPage = this.options.stayOnPage;
        window.ProductGroupsPlugin.spaNavigate = true;
        if (document.title && document.title.indexOf("[Product Groups]") > -1) {
            window.ProductGroupsPlugin.pageTitleTemplate = document.title;
        }
        this.$watch("group", function () {
            if (_this.group != null) {
                _this.loadGroupFullDesc();
            }
        }, { immediate: true });
    };
    Object.defineProperty(ThumbnailView.prototype, "groups", {
        get: function () {
            if (this.options.showXThumbnails) {
                var originalThumbnails = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentGroupChildren(this.options);
                var partialThumbnails = originalThumbnails.slice(0, this.options.showXThumbnails);
                return partialThumbnails;
            }
            else {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentGroupChildren(this.options);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThumbnailView.prototype, "group", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentGroupObject(this.options);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThumbnailView.prototype, "groupDesc", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentGroupObject(this.options).GroupDesc;
        },
        enumerable: true,
        configurable: true
    });
    ThumbnailView.prototype.loadGroupFullDesc = function () {
        var _this = this;
        this.currentFullDesc = "";
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentGroupObject(this.options).GroupCode) {
            $.getJSON(this.options.ajaxUrl +
                "&getFullDescription=" +
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentGroupObject(this.options).GroupCode).done(function (data) {
                var descData;
                if (typeof data === "string") {
                    descData = { Description: data };
                }
                else {
                    descData = data;
                }
                _this.currentFullDesc = descData.Description || "";
                if (descData.MetaDesc) {
                    var descElement = document.querySelector("meta[name=\"description\"]");
                    if (descElement) {
                        descElement.setAttribute("content", descData.MetaDesc);
                    }
                }
            });
        }
    };
    ThumbnailView.prototype.eachDescription = function (item) {
        if (this.options.showEachDescription) {
            return item.GroupDesc;
        }
        else {
            return "";
        }
    };
    ThumbnailView.prototype.getSubCategories = function (item) {
        return item.Children;
    };
    Object.defineProperty(ThumbnailView.prototype, "listThumbnails", {
        get: function () {
            if (this.options.showXThumbnails) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])()
                    .currentGroupChildren(this.options)
                    .slice(this.options.showXThumbnails, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentGroupChildren(this.options).length);
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vuety__["Data"]
    ], ThumbnailView.prototype, "currentFullDesc", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Lifecycle"])()
    ], ThumbnailView.prototype, "mounted", null);
    ThumbnailView = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Component"])({
            template: document.getElementById(templateElement)
                ? "#" + templateElement
                : __webpack_require__(20),
            mixins: [__WEBPACK_IMPORTED_MODULE_2__base__["a" /* BaseView */]],
        })
    ], ThumbnailView);
    return ThumbnailView;
}(__WEBPACK_IMPORTED_MODULE_4_vue___default.a));


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(9)))

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TreeView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuety___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuety__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__treeList__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var templateElement = "v-tmpl-grouptree";
var TreeView = /** @class */ (function (_super) {
    __extends(TreeView, _super);
    function TreeView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TreeView.prototype, "groups", {
        get: function () {
            if (this.options.rootGroup) {
                var child = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["a" /* findChild */])(this.options.rootGroup, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentData.Groups);
                if (!child) {
                    console.warn("No group data found for root group:", "'" + this.options.rootGroup + "'.", "This may be because the group is obsolete.");
                    return [];
                }
                return child.Children;
            }
            else {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__root__["b" /* getRoot */])().currentData.Groups;
            }
        },
        enumerable: true,
        configurable: true
    });
    TreeView = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuety__["Component"])({
            template: document.getElementById(templateElement)
                ? "#" + templateElement
                : __webpack_require__(21),
            components: { "tree-list": __WEBPACK_IMPORTED_MODULE_3__treeList__["a" /* TreeList */] },
            mixins: [__WEBPACK_IMPORTED_MODULE_2__base__["a" /* BaseView */]]
        })
    ], TreeView);
    return TreeView;
}(__WEBPACK_IMPORTED_MODULE_4_vue___default.a));



/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(10);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js